import { render, staticRenderFns } from "./ThirdFrame.vue?vue&type=template&id=3423202a&"
import script from "./ThirdFrame.vue?vue&type=script&lang=js&"
export * from "./ThirdFrame.vue?vue&type=script&lang=js&"
import style0 from "./ThirdFrame.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports